
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TestEquipmentMeasurementSpecifications from '../edit/TestEquipmentMeasurementSpecifications';
import { MeasurementSpecificationTemplate } from '../../backend/backendapi';
import MeasurementSpecificationTemplateMedias from './MeasurementSpecificationTemplateMedias';

@Component({
  components: {
    MeasurementSpecificationTemplateMedias,
    TestEquipmentMeasurementSpecifications,
  },
})
export default class MeasurementSpecificationTemplateEditor extends Vue {
  @Prop({ default: true })
  readonly template!: MeasurementSpecificationTemplate;
  @Prop({ default: true })
  readonly editable!: boolean;
}
